import { render, staticRenderFns } from "./VideoHeader.vue?vue&type=template&id=b691fc5c&scoped=true&"
import script from "./VideoHeader.vue?vue&type=script&lang=js&"
export * from "./VideoHeader.vue?vue&type=script&lang=js&"
import style0 from "./VideoHeader.vue?vue&type=style&index=0&id=b691fc5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b691fc5c",
  null
  
)

export default component.exports